// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: analyst.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FilterOperator, filterOperatorFromJSON, filterOperatorToJSON } from "./enums";
import { BenchmarkEntityProto, KGColumnProto } from "./knowledege_graph";
import { FilterProto, Header, MetricProto } from "./metadata";

export const protobufPackage = "com.meritic.newton";

/** Representation of a column scope. */
export interface ColumnScopeProto {
  /** Referenced KG column in column scope. */
  kg_column?:
    | KGColumnProto
    | undefined;
  /** Operator in the column scope expression. */
  operator?:
    | FilterOperator
    | undefined;
  /** Values in the filter expression. */
  values: string[];
  /** Hidden column scope is used in data scope definition for the analyst. */
  is_hidden?:
    | boolean
    | undefined;
  /** Available values for this column. */
  available_values: string[];
}

/** Scope of the data. */
export interface DataScopeProto {
  /** Guidelines / instructions to use the data scope. */
  instructions?: string | undefined;
  metrics: MetricProto[];
  benchmarks: BenchmarkEntityProto[];
  /**
   * If there is only kg column in the filter without operator and values,
   * then entire column is in the scope. If there are operator and values in the
   * filter, then those specific values are in the scope.
   */
  column_scopes: ColumnScopeProto[];
  /** Flag to indicate if the default scope should be used. */
  use_default_scope?:
    | boolean
    | undefined;
  /** Date epoch in milliseconds when the data scope was last refreshed. */
  last_refresh_time_ms?: number | undefined;
}

/** Scenario configurations. */
export interface ScenarioAnalysis {
  /** Scenario id(UUID). */
  id?:
    | string
    | undefined;
  /** Flag to represent if scenario is enabled or not. */
  disable?:
    | boolean
    | undefined;
  /** Description of the issue or scenario. */
  issue?:
    | string
    | undefined;
  /** Trigger conditions that activate this scenario. */
  trigger?:
    | string
    | undefined;
  /** Investigation steps to diagnose the root cause. */
  investigation_protocol?:
    | string
    | undefined;
  /** Reporting instructions for the scenario. */
  reporting_instructions?:
    | string
    | undefined;
  /** Analysis instruction for the scenario. */
  analysis_instructions?:
    | string
    | undefined;
  /** Subset of the analyst data scope, specific to this scenario. */
  scope_subset?:
    | DataScopeProto
    | undefined;
  /** Filters to set for the scenario to execute. */
  preset_filters: FilterProto[];
}

/** Analyst configuration. */
export interface AnalystProto {
  /** Header containing metadata about the analyst. */
  header?:
    | Header
    | undefined;
  /** Role of an analyst. */
  role?:
    | string
    | undefined;
  /** Guidelines / instructions for the analyst to follow. */
  instructions?:
    | string
    | undefined;
  /** Notes. */
  notes?:
    | string
    | undefined;
  /** Date scope. */
  data_scope?:
    | DataScopeProto
    | undefined;
  /** Scenarios. */
  scenarios: ScenarioAnalysis[];
}

function createBaseColumnScopeProto(): ColumnScopeProto {
  return { kg_column: undefined, operator: undefined, values: [], is_hidden: undefined, available_values: [] };
}

export const ColumnScopeProto: MessageFns<ColumnScopeProto> = {
  encode(message: ColumnScopeProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kg_column !== undefined) {
      KGColumnProto.encode(message.kg_column, writer.uint32(10).fork()).join();
    }
    if (message.operator !== undefined) {
      writer.uint32(16).int32(message.operator);
    }
    for (const v of message.values) {
      writer.uint32(26).string(v!);
    }
    if (message.is_hidden !== undefined) {
      writer.uint32(32).bool(message.is_hidden);
    }
    for (const v of message.available_values) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColumnScopeProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColumnScopeProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.kg_column = KGColumnProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.operator = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.values.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_hidden = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.available_values.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColumnScopeProto {
    return {
      kg_column: isSet(object.kg_column) ? KGColumnProto.fromJSON(object.kg_column) : undefined,
      operator: isSet(object.operator) ? filterOperatorFromJSON(object.operator) : undefined,
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.String(e)) : [],
      is_hidden: isSet(object.is_hidden) ? globalThis.Boolean(object.is_hidden) : undefined,
      available_values: globalThis.Array.isArray(object?.available_values)
        ? object.available_values.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ColumnScopeProto): unknown {
    const obj: any = {};
    if (message.kg_column !== undefined) {
      obj.kg_column = KGColumnProto.toJSON(message.kg_column);
    }
    if (message.operator !== undefined) {
      obj.operator = filterOperatorToJSON(message.operator);
    }
    if (message.values?.length) {
      obj.values = message.values;
    }
    if (message.is_hidden !== undefined) {
      obj.is_hidden = message.is_hidden;
    }
    if (message.available_values?.length) {
      obj.available_values = message.available_values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColumnScopeProto>, I>>(base?: I): ColumnScopeProto {
    return ColumnScopeProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColumnScopeProto>, I>>(object: I): ColumnScopeProto {
    const message = createBaseColumnScopeProto();
    message.kg_column = (object.kg_column !== undefined && object.kg_column !== null)
      ? KGColumnProto.fromPartial(object.kg_column)
      : undefined;
    message.operator = object.operator ?? undefined;
    message.values = object.values?.map((e) => e) || [];
    message.is_hidden = object.is_hidden ?? undefined;
    message.available_values = object.available_values?.map((e) => e) || [];
    return message;
  },
};

function createBaseDataScopeProto(): DataScopeProto {
  return {
    instructions: undefined,
    metrics: [],
    benchmarks: [],
    column_scopes: [],
    use_default_scope: undefined,
    last_refresh_time_ms: undefined,
  };
}

export const DataScopeProto: MessageFns<DataScopeProto> = {
  encode(message: DataScopeProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instructions !== undefined) {
      writer.uint32(10).string(message.instructions);
    }
    for (const v of message.metrics) {
      MetricProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.benchmarks) {
      BenchmarkEntityProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.column_scopes) {
      ColumnScopeProto.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.use_default_scope !== undefined) {
      writer.uint32(40).bool(message.use_default_scope);
    }
    if (message.last_refresh_time_ms !== undefined) {
      writer.uint32(72).int64(message.last_refresh_time_ms);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataScopeProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataScopeProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.instructions = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metrics.push(MetricProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.benchmarks.push(BenchmarkEntityProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.column_scopes.push(ColumnScopeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.use_default_scope = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.last_refresh_time_ms = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataScopeProto {
    return {
      instructions: isSet(object.instructions) ? globalThis.String(object.instructions) : undefined,
      metrics: globalThis.Array.isArray(object?.metrics) ? object.metrics.map((e: any) => MetricProto.fromJSON(e)) : [],
      benchmarks: globalThis.Array.isArray(object?.benchmarks)
        ? object.benchmarks.map((e: any) => BenchmarkEntityProto.fromJSON(e))
        : [],
      column_scopes: globalThis.Array.isArray(object?.column_scopes)
        ? object.column_scopes.map((e: any) => ColumnScopeProto.fromJSON(e))
        : [],
      use_default_scope: isSet(object.use_default_scope) ? globalThis.Boolean(object.use_default_scope) : undefined,
      last_refresh_time_ms: isSet(object.last_refresh_time_ms)
        ? globalThis.Number(object.last_refresh_time_ms)
        : undefined,
    };
  },

  toJSON(message: DataScopeProto): unknown {
    const obj: any = {};
    if (message.instructions !== undefined) {
      obj.instructions = message.instructions;
    }
    if (message.metrics?.length) {
      obj.metrics = message.metrics.map((e) => MetricProto.toJSON(e));
    }
    if (message.benchmarks?.length) {
      obj.benchmarks = message.benchmarks.map((e) => BenchmarkEntityProto.toJSON(e));
    }
    if (message.column_scopes?.length) {
      obj.column_scopes = message.column_scopes.map((e) => ColumnScopeProto.toJSON(e));
    }
    if (message.use_default_scope !== undefined) {
      obj.use_default_scope = message.use_default_scope;
    }
    if (message.last_refresh_time_ms !== undefined) {
      obj.last_refresh_time_ms = Math.round(message.last_refresh_time_ms);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataScopeProto>, I>>(base?: I): DataScopeProto {
    return DataScopeProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataScopeProto>, I>>(object: I): DataScopeProto {
    const message = createBaseDataScopeProto();
    message.instructions = object.instructions ?? undefined;
    message.metrics = object.metrics?.map((e) => MetricProto.fromPartial(e)) || [];
    message.benchmarks = object.benchmarks?.map((e) => BenchmarkEntityProto.fromPartial(e)) || [];
    message.column_scopes = object.column_scopes?.map((e) => ColumnScopeProto.fromPartial(e)) || [];
    message.use_default_scope = object.use_default_scope ?? undefined;
    message.last_refresh_time_ms = object.last_refresh_time_ms ?? undefined;
    return message;
  },
};

function createBaseScenarioAnalysis(): ScenarioAnalysis {
  return {
    id: undefined,
    disable: undefined,
    issue: undefined,
    trigger: undefined,
    investigation_protocol: undefined,
    reporting_instructions: undefined,
    analysis_instructions: undefined,
    scope_subset: undefined,
    preset_filters: [],
  };
}

export const ScenarioAnalysis: MessageFns<ScenarioAnalysis> = {
  encode(message: ScenarioAnalysis, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.disable !== undefined) {
      writer.uint32(16).bool(message.disable);
    }
    if (message.issue !== undefined) {
      writer.uint32(26).string(message.issue);
    }
    if (message.trigger !== undefined) {
      writer.uint32(34).string(message.trigger);
    }
    if (message.investigation_protocol !== undefined) {
      writer.uint32(42).string(message.investigation_protocol);
    }
    if (message.reporting_instructions !== undefined) {
      writer.uint32(50).string(message.reporting_instructions);
    }
    if (message.analysis_instructions !== undefined) {
      writer.uint32(58).string(message.analysis_instructions);
    }
    if (message.scope_subset !== undefined) {
      DataScopeProto.encode(message.scope_subset, writer.uint32(66).fork()).join();
    }
    for (const v of message.preset_filters) {
      FilterProto.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenarioAnalysis {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioAnalysis();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.disable = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.issue = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.trigger = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.investigation_protocol = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.reporting_instructions = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.analysis_instructions = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.scope_subset = DataScopeProto.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.preset_filters.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenarioAnalysis {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      disable: isSet(object.disable) ? globalThis.Boolean(object.disable) : undefined,
      issue: isSet(object.issue) ? globalThis.String(object.issue) : undefined,
      trigger: isSet(object.trigger) ? globalThis.String(object.trigger) : undefined,
      investigation_protocol: isSet(object.investigation_protocol)
        ? globalThis.String(object.investigation_protocol)
        : undefined,
      reporting_instructions: isSet(object.reporting_instructions)
        ? globalThis.String(object.reporting_instructions)
        : undefined,
      analysis_instructions: isSet(object.analysis_instructions)
        ? globalThis.String(object.analysis_instructions)
        : undefined,
      scope_subset: isSet(object.scope_subset) ? DataScopeProto.fromJSON(object.scope_subset) : undefined,
      preset_filters: globalThis.Array.isArray(object?.preset_filters)
        ? object.preset_filters.map((e: any) => FilterProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScenarioAnalysis): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.disable !== undefined) {
      obj.disable = message.disable;
    }
    if (message.issue !== undefined) {
      obj.issue = message.issue;
    }
    if (message.trigger !== undefined) {
      obj.trigger = message.trigger;
    }
    if (message.investigation_protocol !== undefined) {
      obj.investigation_protocol = message.investigation_protocol;
    }
    if (message.reporting_instructions !== undefined) {
      obj.reporting_instructions = message.reporting_instructions;
    }
    if (message.analysis_instructions !== undefined) {
      obj.analysis_instructions = message.analysis_instructions;
    }
    if (message.scope_subset !== undefined) {
      obj.scope_subset = DataScopeProto.toJSON(message.scope_subset);
    }
    if (message.preset_filters?.length) {
      obj.preset_filters = message.preset_filters.map((e) => FilterProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioAnalysis>, I>>(base?: I): ScenarioAnalysis {
    return ScenarioAnalysis.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioAnalysis>, I>>(object: I): ScenarioAnalysis {
    const message = createBaseScenarioAnalysis();
    message.id = object.id ?? undefined;
    message.disable = object.disable ?? undefined;
    message.issue = object.issue ?? undefined;
    message.trigger = object.trigger ?? undefined;
    message.investigation_protocol = object.investigation_protocol ?? undefined;
    message.reporting_instructions = object.reporting_instructions ?? undefined;
    message.analysis_instructions = object.analysis_instructions ?? undefined;
    message.scope_subset = (object.scope_subset !== undefined && object.scope_subset !== null)
      ? DataScopeProto.fromPartial(object.scope_subset)
      : undefined;
    message.preset_filters = object.preset_filters?.map((e) => FilterProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAnalystProto(): AnalystProto {
  return {
    header: undefined,
    role: undefined,
    instructions: undefined,
    notes: undefined,
    data_scope: undefined,
    scenarios: [],
  };
}

export const AnalystProto: MessageFns<AnalystProto> = {
  encode(message: AnalystProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.role !== undefined) {
      writer.uint32(18).string(message.role);
    }
    if (message.instructions !== undefined) {
      writer.uint32(26).string(message.instructions);
    }
    if (message.notes !== undefined) {
      writer.uint32(34).string(message.notes);
    }
    if (message.data_scope !== undefined) {
      DataScopeProto.encode(message.data_scope, writer.uint32(42).fork()).join();
    }
    for (const v of message.scenarios) {
      ScenarioAnalysis.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalystProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalystProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.instructions = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.data_scope = DataScopeProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.scenarios.push(ScenarioAnalysis.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalystProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      role: isSet(object.role) ? globalThis.String(object.role) : undefined,
      instructions: isSet(object.instructions) ? globalThis.String(object.instructions) : undefined,
      notes: isSet(object.notes) ? globalThis.String(object.notes) : undefined,
      data_scope: isSet(object.data_scope) ? DataScopeProto.fromJSON(object.data_scope) : undefined,
      scenarios: globalThis.Array.isArray(object?.scenarios)
        ? object.scenarios.map((e: any) => ScenarioAnalysis.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AnalystProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.role !== undefined) {
      obj.role = message.role;
    }
    if (message.instructions !== undefined) {
      obj.instructions = message.instructions;
    }
    if (message.notes !== undefined) {
      obj.notes = message.notes;
    }
    if (message.data_scope !== undefined) {
      obj.data_scope = DataScopeProto.toJSON(message.data_scope);
    }
    if (message.scenarios?.length) {
      obj.scenarios = message.scenarios.map((e) => ScenarioAnalysis.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalystProto>, I>>(base?: I): AnalystProto {
    return AnalystProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalystProto>, I>>(object: I): AnalystProto {
    const message = createBaseAnalystProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.role = object.role ?? undefined;
    message.instructions = object.instructions ?? undefined;
    message.notes = object.notes ?? undefined;
    message.data_scope = (object.data_scope !== undefined && object.data_scope !== null)
      ? DataScopeProto.fromPartial(object.data_scope)
      : undefined;
    message.scenarios = object.scenarios?.map((e) => ScenarioAnalysis.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
